{
  "name": "backoffice",
  "version": "0.2.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4210 --no-hmr",
    "start:dev": "ng serve --port 4210 --no-hmr --configuration development",
    "start:test": "ng serve --port 4210 --no-hmr --configuration test",
    "start:prod": "ng serve --port 4210 --no-hmr --configuration production",
    "build": "ng build",
    "build:test": "ng build --configuration test",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --browsers=ChromeHeadless",
    "format": "npx prettier --write 'src/**/*.{ts,scss,html}'",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org doktar-hq --project backoffice ./dist/backoffice && sentry-cli sourcemaps upload --org doktar-hq --project backoffice ./dist/backoffice",
    "generate-proxy-win": "cd nswag && generate-proxy.bat",
    "generate-proxy-win:dev": "cd nswag && generate-proxy.bat development",
    "generate-proxy-win:test": "cd nswag && generate-proxy.bat test",
    "generate-proxy-win:prod": "cd nswag && generate-proxy.bat production",
    "generate-proxy-macos": "cd nswag && sh generate-proxy.sh",
    "generate-proxy-macos:dev": "cd nswag && sh generate-proxy.sh development",
    "generate-proxy-macos:test": "cd nswag && sh generate-proxy.sh test",
    "generate-proxy-macos:prod": "cd nswag && sh generate-proxy.sh production",
    "generate-proxy": "cd nswag && sh generate-proxy.sh",
    "generate-proxy:dev": "cd nswag && sh generate-proxy.sh development",
    "generate-proxy:test": "cd nswag && sh generate-proxy.sh test",
    "generate-proxy:prod": "cd nswag && sh generate-proxy.sh production",
    "shake-proxies": "node scripts/shake-proxies.mjs",
    "shake-proxies:dry": "node scripts/shake-proxies.mjs --dry-run",
    "kill-port": "npx kill-port 4210",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.13",
    "@angular/common": "^19.2.13",
    "@angular/compiler": "^19.2.13",
    "@angular/core": "^19.2.13",
    "@angular/forms": "^19.2.13",
    "@angular/platform-browser": "^19.2.13",
    "@angular/platform-browser-dynamic": "^19.2.13",
    "@angular/router": "^19.2.13",
    "@angular/service-worker": "^19.2.13",
    "@microsoft/signalr": "^8.0.7",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@phosphor-icons/web": "^2.1.2",
    "@primeng/themes": "^19.1.3",
    "@sentry/angular": "^9.22.0",
    "@sentry/cli": "^2.45.0",
    "bootstrap": "^5.3.6",
    "crypto-js": "^4.2.0",
    "jspdf": "^3.0.1",
    "jspdf-autotable": "^5.0.2",
    "lodash": "^4.17.21",
    "luxon": "^3.6.1",
    "marked": "^16.4.1",
    "nswag": "^14.4.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.3",
    "rxjs": "~7.8.2",
    "tslib": "~2.8.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.13",
    "@angular-eslint/builder": "^19.5.0",
    "@angular-eslint/eslint-plugin": "^19.5.0",
    "@angular-eslint/eslint-plugin-template": "^19.5.0",
    "@angular-eslint/schematics": "^19.5.0",
    "@angular-eslint/template-parser": "^19.5.0",
    "@angular/cli": "^19.2.13",
    "@angular/compiler-cli": "^19.2.13",
    "@playwright/test": "^1.52.0",
    "@types/crypto-js": "^4.2.2",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "^5.1.8",
    "@types/lodash": "^4.17.17",
    "@types/luxon": "^3.6.2",
    "@types/node": "~24.3.0",
    "@typescript-eslint/eslint-plugin": "^8.32.1",
    "@typescript-eslint/parser": "^8.32.1",
    "eslint": "^9.27.0",
    "eslint-config-prettier": "^10.1.5",
    "eslint-plugin-prettier": "^5.4.0",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "jasmine-core": "^5.7.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-cli": "^2.0.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "playwright-ng-schematics": "^2.0.3",
    "prettier": "^3.5.3",
    "prettier-eslint": "^16.4.2",
    "typescript": "^5.8.3"
  }
}
